import { forwardRef } from "react";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./shared";
import { track } from "../../lib/analytics";

export const FinalCta = forwardRef((_, ref) => {
  const goToSecure = () => {
    track("cta_create_source_code", { location: "final_cta" });
    document.getElementById("secure")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section ref={ref} id="get-code" className="relative" data-testid="final-cta-section">
      <div className="relative overflow-hidden bg-[#FF4D0A] text-[#0B0B0C] py-16 sm:py-24 lg:py-32">
        <div className="relative mx-auto max-w-6xl px-5 sm:px-8">
          <Reveal>
            <p className="font-mono-brand text-[10px] sm:text-xs tracking-[0.3em] uppercase font-bold" data-testid="final-cta-eyebrow">
              Available now
            </p>
            <h2 className="h-heavy text-5xl sm:text-7xl lg:text-8xl leading-[0.92] mt-5" data-testid="final-cta-headline">
              Life runs better
              <br />
              <span className="text-[#F2F0EB]">when you know your code.</span>
            </h2>
          </Reveal>
        </div>
      </div>

      <div className="bg-[#F2F0EB] text-[#0B0B0C] py-14 sm:py-20">
        <div className="mx-auto max-w-6xl px-5 sm:px-8">
          <Reveal>
            <p className="text-[#45403A] font-medium leading-relaxed max-w-xl">
              One signup covers everything. Create your Source Code and it all
              arrives in one email: your code, your full read and your invite to
              the app.
            </p>
          </Reveal>

          <Reveal delay={0.15}>
            <button
              onClick={goToSecure}
              className="mt-10 bg-[#0B0B0C] text-[#FF4D0A] h-heavy text-xl tracking-wide px-10 py-4 flex items-center gap-2 hover:bg-[#1a1c20] transition-colors"
              data-testid="final-cta-button"
            >
              Get my code
              <ArrowRight size={18} />
            </button>
          </Reveal>

          <Reveal delay={0.25}>
            <p className="mt-8 font-mono-brand text-[10px] tracking-[0.25em] uppercase text-[#8A8378]" data-testid="final-trust-line">
              3-day free trial &nbsp;·&nbsp; Cancel any time &nbsp;·&nbsp; Your code stays yours
            </p>
          </Reveal>
        </div>
      </div>

      <div className="bg-[#0B0B0C] py-14 sm:py-20 border-b border-[#F2F0EB]/10">
        <div className="mx-auto max-w-6xl px-5 sm:px-8">
          <Reveal>
            <p className="h-heavy text-5xl sm:text-6xl lg:text-7xl leading-[0.95] text-[#F2F0EB]" data-testid="final-statement-band">
              Not prediction.
              <br />
              <span className="text-[#FF4D0A]">Direction.</span>
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
});
